import { useIntercom } from 'react-use-intercom';

// If a user doesn't allow third party cookies, the IntercomProvider will not exist.
// As a result, we need to safely access the hook.
export const useSafeIntercom: () =>
	| import('react-use-intercom').IntercomContextValues
	| undefined = () => {
	try {
		return useIntercom();
	} catch (err) {
		return;
	}
};
